__webpack_require__.p = "/tokens-border-radius-update/system-email-templates/";